import React, { useEffect } from "react";
import CustomDataModal from "../../../components/UI/CustomDataModal";
import CustomModal from "../../../components/UI/CustomModal";
import CustomTable from "../../../components/UI/Table";
import {
  getAdminBookMakerCricketAPI,
  getAdminUserBookAPI,
  getAdminUserBookCricketAPI,
} from "../../../service/cricket";
import {
  getAdminBookMakerSoccerAPI,
  getAdminBookMakerTennisAPI,
  getAdminUserBookSoccerAPI,
  getAdminUserBookTennisAPI,
} from "../../../service/soccer&tennis";

export default function BookMakersBook({
  eventId,
  isOpen,
  type,
  onClose,
  gameType,
}) {
  const [columns, setColumns] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const getBookMakerBook = async () => {
    let result;
    if (type == "user") {
      if (gameType === "cricket") {
        result = await getAdminUserBookCricketAPI(eventId);
      } else if (gameType === "soccer") {
        result = await getAdminUserBookSoccerAPI(eventId);
      } else if (gameType === "tennis") {
        result = await getAdminUserBookTennisAPI(eventId);
      }
    } else if (type == "book") {
      if (gameType === "cricket") {
        result = await getAdminBookMakerCricketAPI(eventId);
      } else if (gameType === "soccer") {
        result = await getAdminBookMakerSoccerAPI(eventId);
      } else if (gameType === "tennis") {
        result = await getAdminBookMakerTennisAPI(eventId);
      }
    }
    const response = result?.response;
    const data = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
        ? response.data
        : [];
    if (data.length) {
      let rows_ = [];
      let columns_ = [];
      data.map((item) => {
        let row = {};
        row.userName = item?.userName;
        item?.runnerBookResponseDTOS?.map((match) => {
          row[match?.runnerName] = match?.pandL;
        });
        rows_.push(row);
      });
      if (rows_.length > 0) {
        columns_.push({ name: "User Name", id: "userName" });
        Object.keys(rows_[0]).map((key) => {
          if (key !== "userName") {
            columns_.push({ name: key, id: key });
          }
        });
        setColumns(columns_);
        setRows(rows_);
      }
    }
  };

  useEffect(() => {
    getBookMakerBook();
  }, [eventId, gameType]);
  return (
    <CustomDataModal
      header={type == "book" ? "Bookmaker Book" : "User Book"}
      onClose={onClose}
      isOpen={isOpen}
    >
      <CustomTable columns={columns} rows={rows} />
    </CustomDataModal>
  );
}
